export const PRODUCT_CATEGORIES = [
  {
    id: "healthy_indian_namkeen",
    key: "namkeen",
    en: {
      title: "Healthy Indian Namkeen",
      sub: "Export Quality · Natural Ingredients",
      desc: "Discover a premium range of Indian Namkeen snacks that redefine healthy indulgence. Our products are prepared using high-quality natural ingredients, trans-fat-free oils, and time-tested traditional recipes — offering a snacking experience that is as nutritious as it is flavorful. Manufactured in certified facilities with strict hygiene standards, our Namkeen is trusted by importers and distributors across the globe for its consistent quality, authentic taste, and health-conscious formulation.",
    },
    hi: {
      title: "हेल्दी इंडियन नमकीन",
      sub: "निर्यात गुणवत्ता · प्राकृतिक सामग्री",
      desc: "भारतीय नमकीन स्नैक्स की प्रीमियम रेंज, जो स्वस्थ स्वाद की नई परिभाषा है। हमारे उत्पाद उच्च गुणवत्ता वाली प्राकृतिक सामग्री, ट्रांस-फैट-मुक्त तेलों और पारंपरिक विधियों से तैयार किए जाते हैं। प्रमाणित इकाइयों में कड़े स्वच्छता मानकों के साथ निर्मित हमारी नमकीन अपनी निरंतर गुणवत्ता, प्रामाणिक स्वाद और स्वास्थ्य-अनुकूल संरचना के लिए विश्व भर के आयातकों की पसंद है।",
    },
    img: "/product_one.jpeg",
    imgContain: true,
  },
  {
    id: "chemicals",
    key: "chemicals",
    en: { title: "Chemicals", sub: "Organic & Inorganic" },
    hi: { title: "रसायन", sub: "जैविक व अजैविक" },
    img: "https://images.unsplash.com/photo-1532094349884-543bc11b234d",
  },
  {
    id: "garments",
    key: "garments",
    en: { title: "Garments", sub: "Cotton & Man-Made Fibres" },
    hi: { title: "वस्त्र", sub: "सूती व सिंथेटिक फाइबर" },
    img: "https://images.unsplash.com/photo-1768746350424-ee28a364dcf5",
  },
  {
    id: "plastic_products",
    key: "plastic",
    en: { title: "Plastic Products", sub: "Packaging & Pipes" },
    hi: { title: "प्लास्टिक उत्पाद", sub: "पैकेजिंग व पाइप्स" },
    img: "https://images.pexels.com/photos/18631424/pexels-photo-18631424.jpeg",
  },
  {
    id: "turmeric_coriander",
    key: "spices",
    en: {
      title: "Turmeric & Coriander",
      sub: "Pure Ground Spices · Premium Export Quality",
      desc: "Sourced directly from India's premier spice growing belts under strict quality standards. Processed carefully to retain natural aroma, vibrant color, and rich nutritional value for international markets.",
      link: "/turmeric-coriander.html"
    },
    hi: {
      title: "हल्दी और धनिया",
      sub: "शुद्ध पिसे मसाले · प्रीमियम निर्यात गुणवत्ता",
      desc: "कड़े गुणवत्ता मानकों के तहत भारत के प्रमुख मसाला उत्पादक क्षेत्रों से सीधे प्राप्त। अंतरराष्ट्रीय बाजारों के लिए प्राकृतिक सुगंध, जीवंत रंग और समृद्ध पोषण मूल्य बनाए रखने के लिए सावधानीपूर्वक संसाधित।",
      link: "/turmeric-coriander.html"
    },
    img: "/indian-spices.jpeg",
  },
  {
    id: "ayurvedic",
    key: "ayurvedic",
    en: { title: "Ayurvedic & Herbal", sub: "Cosmetics & Extracts" },
    hi: { title: "आयुर्वेदिक व हर्बल", sub: "सौंदर्य व अर्क" },
    img: "https://images.unsplash.com/photo-1734607404574-df50e1839d6d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxheXVydmVkaWMlMjBtZWRpY2luZSUyMG5hdHVyYWwlMjBoZXJiYWx8ZW58MHx8fHwxNzgyMDIyMjA3fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "agricultural",
    key: "agri",
    en: { title: "Agricultural Equipment", sub: "Precision Farm Machinery" },
    hi: { title: "कृषि उपकरण", sub: "आधुनिक फार्म मशीनरी" },
    img: "https://images.pexels.com/photos/29465456/pexels-photo-29465456.jpeg",
  },
  {
    id: "engineering_goods",
    key: "engineering",
    en: { title: "Engineering Goods", sub: "Auto Components · Industrial Machinery" },
    hi: { title: "इंजीनियरिंग गुड्स", sub: "ऑटो पार्ट्स · औद्योगिक मशीनरी" },
    img: "https://images.pexels.com/photos/11157438/pexels-photo-11157438.jpeg",
  },
  {
    id: "biodegradable",
    key: "bio",
    en: { title: "Biodegradable Products", sub: "Eco-friendly Packaging" },
    hi: { title: "जैव-अपघटनीय उत्पाद", sub: "पर्यावरण-हितैषी पैकेजिंग" },
    img: "https://images.unsplash.com/photo-1605615923013-f26c14fe7155?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxlY28lMjBmcmllbmRseSUyMGJpb2RlZ3JhZGFibGUlMjBwYWNrYWdpbmd8ZW58MHx8fHwxNzgyNjE5MzU1fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "ev_vehicles",
    key: "ev",
    en: { title: "EV Vehicles", sub: "Electric Three-Wheelers" },
    hi: { title: "ईवी वाहन", sub: "इलेक्ट्रिक तिपहिया" },
    img: "https://images.unsplash.com/photo-1702440976396-5d8ede3aaf8b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxlbGVjdHJpYyUyMHJpY2tzaGF3JTIwMyUyMHdoZWVsZXJ8ZW58MHx8fHwxNzgyNzk3Mzk3fDA&ixlib=rb-4.1.0&q=85",
  },
];

export const HERO_IMG =
  "https://images.pexels.com/photos/35458829/pexels-photo-35458829.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
export const ABOUT_IMG = "https://images.pexels.com/photos/4487383/pexels-photo-4487383.jpeg";
export const HANDSHAKE_IMG =
  "https://images.pexels.com/photos/33175650/pexels-photo-33175650.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const COMPANY = {
  name: "Commercion Exim Pvt Ltd",
  short: "Commercion Exim",
  email: "info@commercionexim.com",
  phone: "+91 98801 0xxxx",
  whatsapp: "91988010xxxx",
  iec: "IEC: WBxxxxxxxx",
  gst: "GST: WBxxxxxxxx",
  address: {
    line1: "KOL120 – Plot No. 1, Lovelock Street",
    line2: "Kolkata – 700019, West Bengal, India",
  },
  social: {
    linkedin: "",
    twitter: "",
    facebook: "",
    instagram: "",
  },
};

export const TESTIMONIALS = [
  {
    quote:
      "Commercion Exim has been our reliable India-side partner for three years. Their QC discipline and shipping punctuality are exceptional.",
    author: "Ahmed Al-Farsi",
    role: "Procurement Head, Al-Rayan Trading",
    country: "UAE",
  },
  {
    quote:
      "From documentation to last-mile handover, everything is handled with clarity. We source engineering components exclusively through them now.",
    author: "Emma Whitaker",
    role: "Category Manager, Whitaker Industrials",
    country: "United Kingdom",
  },
  {
    quote:
      "The team understands what an African importer actually needs — flexible payments, HD product photos, and fast dispatch. Highly recommended.",
    author: "Kwame Osei",
    role: "Managing Director, Osei Global",
    country: "Ghana",
  },
];

export const CLIENT_LOGOS = [
  "Al-Rayan", "Whitaker", "Osei Global", "Nordic Trade Co.", "Meridian Imports",
  "Pacifica LLC", "Bosphorus Trading", "Silverline B.V.",
];
